import React from 'react'
import { components } from 'cng-web-lib'
import HazardousMaterialFormProperties from './HazardousMaterialFormProperties'
import { Grid, Tooltip } from '@material-ui/core'

const {
  button: { CngIconButton }
} = components

const { initialValues } = HazardousMaterialFormProperties.formikProps

function HazardousMaterialEntry(props) {
  const {
    index,
    isLast,
    onAddHazardousMaterial,
    onDeleteHazardousMaterial,
    hazardousMaterial,
    showNotification
  } = props

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md>
        <HazardousMaterialFormProperties.Fields index={index} showNotification={showNotification} />
      </Grid>
      <Grid item xs={12} md='auto'>
        <Grid container spacing={1}>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Add new'>
              <span>
                <CngIconButton
                  icon={['fal', 'plus']}
                  onClick={() => onAddHazardousMaterial(initialValues)}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Clone'>
              <span>
                <CngIconButton
                  icon={['fal', 'copy']}
                  onClick={() => onAddHazardousMaterial({ ...hazardousMaterial, id: undefined })}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          {!isLast && (
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title='Delete'>
                <span>
                  <CngIconButton
                    icon={['fal', 'trash']}
                    onClick={() => onDeleteHazardousMaterial(hazardousMaterial)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default HazardousMaterialEntry
